/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ loadText: NonNullable<unknown> }} Workout_Logging_Plates_UseInputs */

const en_us2_workout_logging_plates_use = /** @type {(inputs: Workout_Logging_Plates_UseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Use ${i?.loadText}`)
};

const pt_br2_workout_logging_plates_use = /** @type {(inputs: Workout_Logging_Plates_UseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Usar ${i?.loadText}`)
};

const es_419_workout_logging_plates_use = /** @type {(inputs: Workout_Logging_Plates_UseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Usar ${i?.loadText}`)
};

const pt_pt2_workout_logging_plates_use = /** @type {(inputs: Workout_Logging_Plates_UseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Usar ${i?.loadText}`)
};

const fr_fr2_workout_logging_plates_use = /** @type {(inputs: Workout_Logging_Plates_UseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Utiliser ${i?.loadText}`)
};

const de_de2_workout_logging_plates_use = /** @type {(inputs: Workout_Logging_Plates_UseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} nehmen`)
};

const it_it2_workout_logging_plates_use = /** @type {(inputs: Workout_Logging_Plates_UseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Usa ${i?.loadText}`)
};

/**
* | output |
* | --- |
* | "Use {loadText}" |
*
* @param {Workout_Logging_Plates_UseInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_plates_use = /** @type {((inputs: Workout_Logging_Plates_UseInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Plates_UseInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_plates_use(inputs)
	if (locale === "es-419") return es_419_workout_logging_plates_use(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_plates_use(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_plates_use(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_plates_use(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_plates_use(inputs)
	return en_us2_workout_logging_plates_use(inputs)
});
export { workout_logging_plates_use as "workout-logging.plates_use" }